export async function readJsonResponseBody(
  response: Response
): Promise<unknown> {
  return response.json().catch(() => ({}));
}

export function messageFromApiErrorBody(
  body: unknown,
  fallback: string
): string {
  if (typeof body === 'object' && body !== null) {
    const b = body as {
      error?: { detail?: { description?: unknown }; title?: unknown };
      message?: unknown;
    };
    // RFC-9457 errors carry the actionable text in error.detail.description, error.title being coarser.
    const description = b.error?.detail?.description;
    if (typeof description === 'string' && description) return description;
    const title = b.error?.title;
    if (typeof title === 'string' && title) return title;
    if (typeof b.message === 'string' && b.message) return b.message;
    if (Array.isArray(b.message)) {
      const joined = b.message.filter((m) => typeof m === 'string').join('; ');
      if (joined) return joined;
    }
  }
  return fallback;
}

export async function throwApiError(
  response: Response,
  fallback: string
): Promise<never> {
  const body = await readJsonResponseBody(response);
  throw new Error(messageFromApiErrorBody(body, fallback));
}

export async function messageFromApiErrorResponse(
  response: Response,
  fallback: string
): Promise<string> {
  return messageFromApiErrorBody(
    await readJsonResponseBody(response),
    fallback
  );
}

export async function readJsonResponseAs<T>(
  response: Response
): Promise<T | null> {
  try {
    return (await response.json()) as T;
  } catch {
    return null;
  }
}
